import React from "react";

import { useTranslation } from "react-i18next";

import { useRootAppStore } from "@hooks";
import classNames from "classnames";

import HeaderItemWrapper from "./HeaderItemWrapper";

export default function HeaderFailedLoginsCheckButton(props: {
	isLabelHidden?: boolean;
}) {
	const { failedLoginsCheckPopupStore } = useRootAppStore();
	const { t } = useTranslation();

	const openPopup = () => {
		failedLoginsCheckPopupStore.togglePopup();
	};

	const btnClasses = classNames(
		"header__logins",
		{
			"header__logins--icon": props.isLabelHidden,
		},
		"btn",
		{
			"btn--sml btn--radial--full": !props.isLabelHidden,
			"btn--round btn--round--sml": props.isLabelHidden,
		},
		"btn--split btn--secondary--inverted btn--icon"
	);

	return (
		<HeaderItemWrapper>
			<button onClick={openPopup} className={btnClasses}>
				<div className="btn btn--round btn--round--xsml btn--split__icon btn--secondary">
					<i className="u-icon u-icon--sml u-icon--failed-login" />
				</div>

				{!props.isLabelHidden && (
					<span className="header__logins__label">
						{t(
							"specific:USER.CHECK_FAILED_LOGINS.FAILED_LOGINS_TITLE"
						)}
					</span>
				)}
			</button>
		</HeaderItemWrapper>
	);
}
